import { render, staticRenderFns } from "./MyIntroduce3.vue?vue&type=template&id=5e2bf2db&scoped=true"
import script from "./MyIntroduce3.vue?vue&type=script&lang=js"
export * from "./MyIntroduce3.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce3.vue?vue&type=style&index=0&id=5e2bf2db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bf2db",
  null
  
)

export default component.exports